const menuToggle = () => {
  const navbarToggler = document.querySelectorAll('.toggler-menu-js');

  navbarToggler.forEach((toggler) => {
    toggler.addEventListener('click', (e) => {
      e.preventDefault();    
      document.querySelector('html').classList.toggle("menu-open");
        navbarToggler.forEach((toggler) => {
          toggler.classList.toggle("is-active");
        });
    });
  })
}

export default menuToggle;
